import { User } from "firebase/auth";
import React from "react";

interface IUserContext {
  user: User;
  logIn: () => void;
  logOut: () => void;
}
export const UserContext = React.createContext<IUserContext>(null!);
